const setLabelFrequency = {
  onDemand: 'BAJO DEMANDA',
  month: 'mes',
  months: 'meses',
  day: 'día',
  days: 'días'
}

export default setLabelFrequency;
